import React from 'react';
import { compose, withHandlers } from 'recompose';
import { withRouter } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import HelpdeskForm from './detail/helpdeskForm';
import withLoader from '../app/withLoader';
import { withSnackbar } from 'notistack';
import { contact } from './_api';

const styles = theme => ({
  root: {
    margin: 10,
  },
  paper: {
    padding: theme.spacing.unit,
    marginBottom: 20,
  },
});

const enhance = compose(
  withSnackbar,
  withStyles(styles),
  withLoader,
  withRouter,
  withHandlers({
    onSubmit: ({ toggleLoader, enqueueSnackbar, history }) => async values => {
      toggleLoader();
      const respUser = await contact({
        email: values.email,
        text: values.text,
      });
      if (respUser) {
        enqueueSnackbar('Váš požadavek byl odeslán.', {
          variant: 'success',
        });
        history.push(`/`);
      } else {
        enqueueSnackbar('Váš požadavek se nepodařilo uložit.', {
          variant: 'error',
        });
      }
      toggleLoader(false);
    },
  })
);

export default enhance(({ classes, onSubmit }) => (
  <div className={classes.root}>
    <h2>Zadat požadavek na helpdesk</h2>
    <Paper className={classes.paper}>
      <HelpdeskForm onSubmit={onSubmit} />
    </Paper>
  </div>
));



// WEBPACK FOOTER //
// ./src/modules/helpdesk/index.js